package com.starparty.app.geometry

import kotlin.math.abs

class SP_Rectangle(
    val left: Double,
    val top: Double,
    width: Double,
    height: Double) {

    val width: Double
    val height: Double

    val right: Double
        get() = left + width

    val bottom: Double
        get() = top - height

    fun contains(x:Double, y:Double): Boolean {
        var isContained = false
        if (x in left..right) {
            if (y in bottom..top) {
                isContained = true
            }
        }

        return isContained
    }

    fun intersects(r: SP_Rectangle): Boolean {
        var intersects = false
        if (r.left <= right && r.right >= left) {
            if (r.bottom <= top && r.top >= bottom) {
                intersects = true
            }
        }
        return intersects
    }

    init {
        this.width = abs(width)
        this.height = abs(height)
    }

}